import refineFilters from "./refine_filters";

up.compiler(".up_qname", function (element) {
  function onChange(event) {
    let new_val = event.target.value;
    refineFilters("qname", new_val);
  }
  element.addEventListener("input", onChange);
  return () => {
    element.removeEventListener("input", onChange);
  };
});
